import { KeyValue } from '@/main/models/common';

export enum FileTypeTypes {
  GET_FILE_TYPE = 'fileType/GET_FILE_TYPE',
  SAVE_FILE_TYPE = 'fileType/SAVE_FILE_TYPE',
  RESET_REDUCER_FILE_TYPE = 'fileType/RESET_REDUCER_FILE_TYPE'
}

export interface FileTypeState {
  readonly fileType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetFileType {
  type: typeof FileTypeTypes.GET_FILE_TYPE;
  payload: {
    idSystemApplication: number
  }
}

export interface SaveFileType {
  type: typeof FileTypeTypes.SAVE_FILE_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerFileType {
  type: typeof FileTypeTypes.RESET_REDUCER_FILE_TYPE;
}


export type FileTypeActionTypes =  SaveFileType | GetFileType | ResetReducerFileType;